export default "__VITE_ASSET__CBpQ4KJu__"